import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Categoria } from '../tiendas/categoria';
import { Tienda } from '../tiendas/tienda';
import { TotemService } from '../totem.service';
import { StorageService } from '../storage.service';
import { DragScrollComponent } from 'ngx-drag-scroll';
import { AnalyticsService } from '../services/analytics.service';


@Component({
  selector: 'app-tienda-detalle',
  templateUrl: './tienda-detalle.component.html',
  styleUrls: ['./tienda-detalle.component.css']
})
export class TiendaDetalleComponent implements OnInit {
  id: number;
  tienda: Tienda;
  categoria: Categoria;
  oferta: any = false;
  ofertas : any = false;
  hayDcto: boolean = false;
  hayDescripcion: boolean = false;
  datosRuta;
  storesTransition: Boolean = false;
  @ViewChild('nav', {read: DragScrollComponent, static: false}) ds: DragScrollComponent;
  imagennodal ='';
  public actual: string = '';


  constructor(private totemService: TotemService, private route: ActivatedRoute,
              public router: Router, private storageService: StorageService,private location: Location,
              private analytics: AnalyticsService) {
                this.actual = this.totemService.actualLanguage;
               }


  

  async ngOnInit () {
    this.datosRuta = await this.storageService.getNodosRuta();
    this.id = parseInt(this.route.snapshot.paramMap.get('id'));
    await this.obtenerTienda();
    if (this.tienda) {
      this.enviarAnalytics(this.tienda);
    }
    await this.obtenerCategoria();
    await this.obtenerOferta();
  }

  async obtenerTienda() {
    try {

      await this.totemService.getTiendas('es').toPromise().then((res: any) => {
        const tiendas = res.map((tienda: any) => new Tienda(tienda))
        this.tienda = tiendas.find((tienda: Tienda) => {
          tienda['numeroFotos'] = tienda.imagenes ? tienda.imagenes.length : 0;
          return tienda.puntoInteres === this.id;
        });
      });
      console.log('datito tienda',this.tienda);
    } catch (err) {
      console.log(err);
    }
  }

  async obtenerCategoria() {
    try {
      await this.totemService.getCategorias(this.actual).toPromise().then((res: any) => {
        const categorias = res.map((categoria: any) => new Categoria(categoria));
        console.log('this.tienda.categoria',this.tienda)
        this.categoria = categorias.find((cat: Categoria) => {
          return cat.id === this.tienda.categoria;
        });
      });
    } catch (err) {
      console.log(err);
    }
  }

  async obtenerOferta() {
    try {
      await this.totemService.geteventos('es').toPromise().then((res: any) => {
        this.oferta = res.find(evento => evento.tipo_evento === "Ofertas" && evento.punto_interes === this.id);
        /*nuevo*/this.ofertas = res.filter(evento => evento.tipo_evento === "Ofertas" && evento.punto_interes === this.id);
        console.log('esto es ofertas y sus propiedades',this.ofertas)
        const titulo = this.oferta? this.oferta.titulo.split('::'): ['',''];
        if (this.oferta)
          this.oferta.tituloNombre = titulo[0];
          this.oferta.tituloDcto = titulo[1];
          this.hayDcto = true;
      });
    } catch (err) {
      console.log(err);
    }
  }

  async iniciarRuta() {
      await this.storageService.setDestino(this.tienda.puntoInteres.toString(), 'tiendas');
      //this.router.navigate([`donde-quiero-ir`]);
      //const resultadoLocal = this.storageService.getNodosRuta();
      const resultadoLocal = JSON.parse(window.localStorage.getItem("nodos"));
      console.log('nodosruta', resultadoLocal);

      // Analytics: inicio de ruta hacia la tienda
      const tipoInicio = resultadoLocal && resultadoLocal.tipoInicio ? resultadoLocal.tipoInicio : '';
      const tipoDestino = resultadoLocal && resultadoLocal.tipoDestino ? resultadoLocal.tipoDestino : '';
      const nombreTienda = this.tienda && this.tienda.nombre ? this.tienda.nombre : '';
      this.analytics.sendRouteStart(tipoInicio, tipoDestino, nombreTienda);

      if (resultadoLocal.tipoInicio === 'Totem') {
        if (resultadoLocal.tipoDestino === 'servicios') {
          this.router.navigate([`mapa/${resultadoLocal.totemInicio || 0}/0/${resultadoLocal.tipoDestino}/${resultadoLocal.destino}`]);
          return;
        }
        this.router.navigate([`mapa/${resultadoLocal.totemInicio || 0}/${resultadoLocal.destino}/${resultadoLocal.tipoDestino}/0`]);
        return;
      }
      this.router.navigate([`donde-quiero-ir`]);
  }

  public open(imagen:string) {
    if(imagen){
      this.imagennodal = imagen;
      document.getElementById("myBtnTienda").click();
    }
  }

  public close() {
    document.getElementById("myBtnclose").click();
  }

    // 4
    changeLanguage(language: any) {
      this.actual = language;
      this.totemService.changeLanguage(language);
    }
    getTranslation(key: string) {
      const word = this.totemService.getTranslation(key);
      if (word){
        return word[0].texto_descripcion;
      }
    }

    public goBack() {
      this.location.back();
    }

    private enviarAnalytics(tienda: Tienda) {
      if (!tienda) { return; }
      const tiendaId = tienda.puntoInteres || this.id;
      const tiendaNombre = tienda.nombre || 'Tienda sin nombre';

      // page_view enriquecido
      this.analytics.sendPageView('/tienda-detalle/' + tiendaId, tiendaNombre, {
        store_id: tiendaId,
        store_name: tiendaNombre
      });

      // evento view_item estandar (GA4)
      this.analytics.sendViewItem(tiendaId, tiendaNombre);
    }
}
